<app-card-select *ngIf="order && orderTypes" [cardData]="dataForCards" [activeValue]="order && order.order_type ? order.order_type.id : undefined" (valueEmitter)="setNewOrderType($event)"></app-card-select>
